import React from 'react';
import { WORLD } from '../config/zones';
import { useStore } from '../store';
import { mulberry32 } from './rng';
import InstancedSpecies from './InstancedSpecies';
import { SPECIES } from './species';

// Aquatic fauna of the neutral Amazon — every species is fully InstancedMesh-backed.
export default function RiverLife() {
  const ws = useStore.getState().worldSeed;
  const r = mulberry32(ws + 41);
  const q = typeof window !== 'undefined' && (new URLSearchParams(window.location.search).get('photo') || new URLSearchParams(window.location.search).get('lowfx') === '1') ? 0.4 : 1;
  const c = (base, span) => Math.max(2, Math.round((base + Math.floor(r() * span)) * q));

  const river = { xMin: WORLD.xMin + 20, xMax: WORLD.xMax - 20, zMin: -8, zMax: 8, y: -0.4 };
  const riverWide = { xMin: WORLD.xMin + 20, xMax: WORLD.xMax - 20, zMin: -12, zMax: 12, y: -0.4 };
  const center = { xMin: WORLD.xMin + 45, xMax: WORLD.xMax - 45, zMin: -3, zMax: 3, y: -0.2 };
  const bankEdge = { xMin: WORLD.xMin + 25, xMax: WORLD.xMax - 25, zMin: -13, zMax: 13, y: -0.3 };
  const shallows = { xMin: WORLD.xMin + 25, xMax: WORLD.xMax - 25, zMin: -18, zMax: 18, y: -0.25 };

  return (
    <group>
      {/* Piranha schools swarm the contested artifacts */}
      <InstancedSpecies parts={SPECIES.piranha} count={c(20, 12)} bounds={river} seed={9000 + ws} behavior="swarm" speciesKey="piranha" />
      {/* River dolphins — the unaligned typology */}
      <InstancedSpecies parts={SPECIES.dolphin} count={c(9, 4)} bounds={riverWide} seed={9200 + ws} behavior="swim" speciesKey="dolphin" />
      {/* Playful river otters */}
      <InstancedSpecies parts={SPECIES.otter} count={c(10, 6)} bounds={riverWide} seed={9400 + ws} behavior="swim" speciesKey="otter" />
      {/* Bull sharks patrol the ideological boundaries and snap at the boat */}
      <InstancedSpecies parts={SPECIES.shark} count={c(10, 4)} bounds={riverWide} seed={9600 + ws} behavior="patrol" speciesKey="shark" />
      {/* Whales (Mega-Donors) — 3 massive breachers down the central channel */}
      <InstancedSpecies parts={SPECIES.whale} count={3} bounds={center} seed={9800 + ws} behavior="whale" speciesKey="whale" />
      {/* Electric Eels (Info Brokers) — darting along the bank edges */}
      <InstancedSpecies parts={SPECIES.eel} count={c(20, 6)} bounds={bankEdge} seed={9900 + ws} behavior="eel" speciesKey="eel" />
      {/* Goldfish (The Distracted Public) — dense schools in the shallows */}
      <InstancedSpecies parts={SPECIES.goldfish} count={c(90, 50)} bounds={shallows} seed={9970 + ws} behavior="school" speciesKey="goldfish" />
    </group>
  );
}
